export default __webpack_public_path__ + "static/prodapt-logo-921180200f55e3bdf2b74f6570b4bb7b.png";